import React, { memo } from 'react';
import { Feature } from 'ol';
import Point from 'ol/geom/Point';
import * as S from '../../LegendAndAdjustments.style';

function LegendVector({ layer }) {
	const label = layer.get('label');
	const styles = layer.getStyle();

	const { icon } = layer.getProperties();
	let styleObj = null;

	// Checa se o estilo é uma função e invoca ela com uma feature simulada
	if (typeof styles === 'function') {
		const feature = new Feature({
			geometry: new Point([0, 0]) // Simule uma geometria qualquer
		});
		styleObj = styles(feature); // Obtenha os estilos da função
	} else if (typeof styles === 'object') {
		styleObj = styles;
	}

	if (styleObj && icon === undefined) {
		// Verifica se o estilo retornado é um array, caso contrário, transforma em array
		const styleArray = Array.isArray(styleObj) ? styleObj : [styleObj];

		return styleArray.map((style, index) => {
			const fill = style.getFill();
			const stroke = style.getStroke();

			return (
				fill && (
					<S.LegendVectorItem key={index}>
						<S.LegendVectorSymbol
							{...{
								colorVector: fill.getColor(),
								colorVectorBorder: stroke.getColor()
							}}
						/>
						<S.LegendVectorName>{label}</S.LegendVectorName>
					</S.LegendVectorItem>
				)
			);
		});
	}

	// Renderiza ícone se estiver presente
	if (icon !== undefined) {
		return (
			<S.LegendVectorItem>
				<S.LegendVectorIcon>
					<img src={icon} alt={`Legenda ${label}`} />
				</S.LegendVectorIcon>
				<S.LegendVectorName>{label}</S.LegendVectorName>
			</S.LegendVectorItem>
		);
	}

	return null;
}

export default memo(LegendVector);
